module.exports = __webpack_public_path__ + "img/chadle2_2.2b754b08.png";